import * as PropTypes from 'prop-types';
import * as React from 'react';
import HideableSlider from './hideable_slider';
import BumpBarGraphic from './bump_bar_graphic';

const BumpChange = ({
  bidSlider,
  impressions,
  salesCount,
  salesSpent,
  salesRevenue,
  showMobileSlider,
  sliderToggle,
  currentBid,
  hasInventory,
}) => (
  <div className="product-bump__wrapper">
    <div className="product-bump__overview-col">
      <h4 className="product-bump__overview-col__stat-heading">{I18n.t('js.bump.change.performance')}</h4>
      <ul className="product-bump__overview-col__stats">
        <li>
          <div className="product-bump__overview-col__stats__stat">
            {impressions}
          </div>
          <div className="product-bump__overview-col__stats__label">
            {I18n.t('js.bump.change.impressions')}
          </div>
        </li>
        {hasInventory &&
          <li>
            <div className="product-bump__overview-col__stats__stat">
              {salesCount}
            </div>
            <div className="product-bump__overview-col__stats__label">
              {I18n.t('js.bump.change.numberSold')}
            </div>
          </li>
        }
        <li>
          <div
            className="product-bump__overview-col__stats__stat"
            dangerouslySetInnerHTML={{ __html: salesSpent }}
          />
          <div className="product-bump__overview-col__stats__label">
            {I18n.t('js.bump.change.spent')}
          </div>
        </li>
        <li>
          <div
            className="product-bump__overview-col__stats__stat"
            dangerouslySetInnerHTML={{ __html: salesRevenue }}
          />
          <div className="product-bump__overview-col__stats__label">
            {I18n.t('js.bump.change.sales')}
          </div>
        </li>
      </ul>
    </div>
    <div className="product-bump__slider-col">
      <HideableSlider
        label={I18n.t('js.bump.change.adjustRate')}
        sliderToggle={sliderToggle}
        showMobileSlider={showMobileSlider}
        currentBid={currentBid}
      >
        <h4 className="product-bump__slider-col__label">{I18n.t('js.bump.change.adjustRate')}</h4>
        <div className="product-bump__views-scale">
          <div className="produt-bump__scale-img">
            <div className="produt-bump__scale-img__inner">
              <BumpBarGraphic
                highlightStartPercentage={50}
                highlightEndPercentage={80}
              />
            </div>
          </div>
          <div className="product-bump__views-scale__more">{I18n.t('js.bump.setup.moreViews')}</div>
          <div className="product-bump__views-scale__most-popular product-bump__views-scale__most-popular--new">
            {I18n.t('js.bump.setup.recommendedTiers')}
          </div>
          <div className="product-bump__views-scale__much-more">{I18n.t('js.bump.setup.manyMoreViews')}</div>
        </div>
        {bidSlider}
      </HideableSlider>
    </div>
  </div>
);

BumpChange.propTypes = {
  bidSlider: PropTypes.element.isRequired,
  impressions: PropTypes.number,
  salesCount: PropTypes.number,
  salesSpent: PropTypes.string,
  salesRevenue: PropTypes.string,
  hasComparisonShoppingPage: PropTypes.bool,
  showMobileSlider: PropTypes.bool,
  sliderToggle: PropTypes.func,
  currentBid: PropTypes.number,
  hasInventory: PropTypes.bool,
};

export default BumpChange;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_change.jsx